import { Component, OnInit, QueryList, ViewChildren } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { FormBuilder, FormControl } from '@angular/forms';
import { NgxSpinnerService } from 'ngx-spinner';
import { AuthServiceService } from '../../shareModule/services/auth-service.service';
import { NgbDate } from '@ng-bootstrap/ng-bootstrap';
import { ApiResponse, SortEvent } from 'src/app/shareModule/models/common.model';
import { NgbdSortableHeader } from 'src/app/shareModule/directive/ngbd-sortable-header/ngbd-sortable-header.directive';
import { Member } from './admin-members-analytics.model';
import { CustomerService } from 'src/app/shareModule/services/customer.service';
import { LocalServiceService } from 'src/app/shareModule/services/local-service.service';

@Component({
  selector: 'app-admin-members-analytics',
  templateUrl: './admin-members-analytics.component.html',
  styleUrls: ['./admin-members-analytics.component.scss'],
})
export class AdminMembersAnalyticsComponent implements OnInit {
  public totalActiveUsers: number = 0;
  public totalReferrals: number = 0;
  public page = 1;
  public pageSize = 10;
  public members: Array<any> = [];
  public totalMembers: Member[] = [];
  public searchText = new FormControl('');
  public searchDate = new FormControl('');
  @ViewChildren(NgbdSortableHeader) headers: QueryList<NgbdSortableHeader>;

  /**
   * Constructor
   */
  constructor(
    private toastr: ToastrService,
    private auth: AuthServiceService,
    private fb: FormBuilder,
    private spinner: NgxSpinnerService,
    private customerService: CustomerService,
    private local: LocalServiceService
  ) { }

  ngOnInit(): void {
    this._getMembersDetails();
    this.getUserState();
  }

  /**
   * get member details based on created date - dateCreated
   */
  private _getMembersDetails(): void {
    this.auth.getMembersDetails().subscribe((response: ApiResponse) => {
      this.totalMembers = response?.body || [];
      this.totalActiveUsers =
        response?.body?.filter((resp: any) => resp.status == 1).length || 0;
      this.nextPage();
    });
  }

  public nextPage(): void {
    this.members = this.totalMembers.slice(
      (this.page - 1) * this.pageSize,
      (this.page - 1) * this.pageSize + this.pageSize
    );
  }

  public search(text: string): void {
    this.members = this.totalMembers.filter((member) => {
      const term = text.toLowerCase();
      return (member?.phone || '' || member?.profileCharacterName).toLowerCase().includes(term);
    });
  }

  public clearSearch(type): void {
    if (type == 'searchText') {
      this.searchText.setValue('');
    } else {
      this.searchDate.setValue('');
    }
    this.nextPage();
  }

  public searchByDate(): void {
    let dateRange: any = this.searchDate.value
    if (dateRange && dateRange[0] && dateRange[1]) {
      this.members = this.totalMembers.filter((member) => {
        if (member.dateCreated) {
          const targetDate = new Date(member.dateCreated);
          return (targetDate >= dateRange[0] && targetDate <= dateRange[1])
        } else {
          return false;
        }
      });
    }
  }

  public disableEnableUser(id, status): void {
    this.auth
      .disableEnableMember(id, status)
      .subscribe((response: ApiResponse) => {
        this.toastr.success(response.message);
        this._getMembersDetails();
      });
  }

  public blockProfile(id) {
    this.customerService
      .updateUserBlockStatus({
        userId: id,
        isAdmin: true
      })
      .subscribe(
        (response: any) => {
          this._getMembersDetails();
          this.toastr.success(
            response.message || 'Profile blocked successfully'
          );
        },
        (e) => {
          this.toastr.error(e.error.message || 'Failed to block profile');
        }
      );
  }
  public deleteProfile(id) {
    this.local.alertConfirm({
      message: "Are you sure want to delete this member ?"
    }).then((resp) => {
      if (resp.isConfirmed) {
        this.customerService
          .deleteUser({
            userId: id,
          })
          .subscribe(
            (response: any) => {
              this._getMembersDetails();
              this.toastr.success(
                response.message || 'Profile deleted successfully'
              );
            },
            (e) => {
              this.toastr.error(e.error.message || 'Failed to delete profile');
            }
          );
      }
    })

  }

  public onSort({ column, direction }: SortEvent): void {
    // resetting other headers - do later
    for (const header of this.headers) {
      if (header.sortable !== column) {
        header.direction = '';
      }
    }

    // sorting countries
    if (direction === '' || column === '') {
      this.nextPage();
    } else {
      this.members = [...this.totalMembers].sort((a, b) => {
        const res = this._compare(a[column], b[column]);
        return direction === 'asc' ? res : -res;
      });
    }
  }

  private _compare(v1: string | number, v2: string | number) {
    return v1 < v2 ? -1 : v1 > v2 ? 1 : 0;
  }

  public getUserState() {
    this.auth.getUsersStatistics().subscribe((response: ApiResponse) => {

      this.totalActiveUsers = response?.body?.activeUsers || 0;
      // this.totalMembers = response?.body?.totalUsers || 0;

    });
  }

  public tasks(referralCode: string) {
    window.open(`${window.location.origin}/user-tasks/${referralCode}`, '_blank');
  }
}
